var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link_button",attrs:{"href":_vm.url,"target":"_blank"}},[(_vm.linkTo == 'tool')?_c('span',[_vm._v("入力補助ツール・補足資料")]):_c('span',[_vm._v("補足資料")])])}
var staticRenderFns = []

export { render, staticRenderFns }